export default "__VITE_ASSET__lU5WMwVu__"